export default __webpack_public_path__ + "static/media/settingsBlack.f9522ae0.svg";